export default {
  // margin: 'auto',
  boxSizing: 'border-box',
  position: 'relative',
  borderStyle: 'solid',
  borderColor: '#197AFA',
  borderRadius: '50%',
  animation: '$ring 1s linear infinite',
  borderTopColor: 'transparent',
};
